import { useEffect } from 'react'

export const APP_COMPANY_CONTACT_IMAGE_LEAVE_MESSAGE = '선택한 이미지는 저장 전에 이동하면 사라집니다. 이동하시겠습니까?'
export const APP_COMPANY_CONTACT_IMAGE_FILE_ACCEPT = '.jpg,.jpeg,.png,.gif,.webp,image/png,image/gif,image/jpeg,image/webp'
export const APP_COMPANY_CONTACT_IMAGE_FILE_ERROR_MESSAGE = '이미지 파일만 업로드할 수 있습니다.'

// 도입문의 이미지 업로드에서 허용하는 파일 형식만 통과시킨다.
export const isCompanyContactImageFile = (file) => {
    return Boolean(file) && (
        (file.type && file.type.startsWith('image/')) ||
        /\.(jpg|jpeg|png|gif|webp)$/i.test(file.name || '')
    )
}

export const hasPendingCompanyContactImage = (imageValue) => {
    return imageValue instanceof File
}

// 업로드 파일은 브라우저 보안상 복구할 수 없어서, 새로고침/탭 닫기 직전에만 기본 경고를 띄운다.
export const usePendingCompanyContactImageUnloadGuard = (enabled) => {
    useEffect(() => {
        if (typeof window === 'undefined' || !enabled) {
            return undefined
        }

        const handleBeforeUnload = (event) => {
            event.preventDefault()
            event.returnValue = ''
            return ''
        }

        window.addEventListener('beforeunload', handleBeforeUnload)

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
        }
    }, [enabled])
}
